/*
 * Public API Surface of lib
 */

export * from './lib/lib.service';
export * from './lib/lib.component';
export * from './lib/lib.module';
